'use client';

import { ActionTab } from '@/components/Shares/ActionTab';
import { CardTitle } from '@/components/Shares/CardTitle';
import { useLingui } from '@lingui/react';
import { Box, Card, Group, Stack } from '@mantine/core';
import { BetsTable } from './BetsTable';
import classes from './BetsTable.module.css';
const text = ['MY BETS', 'ALL BETS', 'HIGH ROLLERS', 'RARE WINS', 'LEADERBOARD'];
export type BetsProps = {
  hasActionTab?: boolean;
};
export const Bets: React.FC<BetsProps> = ({
  hasActionTab
}) => {
  const {
    i18n
  } = useLingui();
  return <Card bg="var(--navbar-bg-color)" radius="sm">
      <Stack>
        <Group justify="space-between" wrap="nowrap">
          <CardTitle firstText={i18n._('Bets')} isFirstGradient colorFrom="#00E5CF" colorTo="#39B54A" iconUrl="/assets/title-icons/7.png" mt={6} />
          {hasActionTab && <ActionTab items={text} activeIndex={1} miw={250} />}
        </Group>

        <Box mah={600} className={classes.scroll} style={{
        maskImage: 'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgb(23 26 30) 25%)'
      }}>
          <BetsTable />
        </Box>
      </Stack>
    </Card>;
};